document.addEventListener('DOMContentLoaded', function () {
  let widgetIdFromUrl = ''
  let widgetIdList = []
  const loadedWidgetIdList = []
  let loadedAllWidgets = false
  const rebuyByobSuggestedDataElem = document.querySelector('#rebuy-byob-suggested-data')
  let rebuyByobSuggestedData = null
  if(rebuyByobSuggestedDataElem) {
    const rebuyByobSuggestedTemp = JSON.parse(rebuyByobSuggestedDataElem.textContent)
    if(rebuyByobSuggestedTemp['list'].length) {
      rebuyByobSuggestedData = rebuyByobSuggestedTemp
    }
  }

  const onSelectSuggestedBundle = (event) => {
    const widgetId = event.target.value
    if(widgetId !== '') {
      history.pushState({}, '', `${rebuyByobSuggestedData['collection_url']}?preset=${widgetId}`)
      renderBySuggestedBundle(widgetId)
    } else {
      history.pushState({}, '', rebuyByobSuggestedData['collection_url'])
      renderBySuggestedBundle(widgetId)
    }
  }

  const getVariantIdFromUrl = (linkElem) => {
    let strArr = linkElem.getAttribute('href').split('variant=')
    const [first, second] = strArr
    strArr = typeof second !== 'undefined' ? second.split('&') : []
    const [variantId] = strArr
    return variantId
  }

  const renderBySuggestedBundle = (widgetId) => {
    const bundleWidgetBlock = document.querySelector(`.rebuy-byob div[data-rebuy-id="${rebuyByobSuggestedData['builder_id']}"]`)
    if(widgetId !== '') {
      const widgetBlock = document.querySelector(`.rebuy-byob div[data-rebuy-id="${widgetId}"]`)
      if(widgetBlock) {
        const variantIds = [...widgetBlock.querySelectorAll('.rebuy-product-title a')].map(link => getVariantIdFromUrl(link))
        if(variantIds.length) {
          if(bundleWidgetBlock) {
            const productBlocks = [...bundleWidgetBlock.querySelectorAll('.rebuy-product-block')]
            productBlocks.forEach(productBlock => {
              const qtyElem = productBlock.querySelector('button.rebuy-bundle-builder__item-quantity-widget-button')
              const titleElem = productBlock.querySelector('a.rebuy-product-title')
              if(qtyElem && titleElem) {
                const variantId = getVariantIdFromUrl(titleElem)
                if(!variantIds.includes(variantId)) {
                  qtyElem.click()
                }
              }
            })

            productBlocks.forEach(productBlock => {
              const titleElem = productBlock.querySelector('a.rebuy-product-title')
              if(titleElem) {
                const variantId = getVariantIdFromUrl(titleElem)
                if(variantIds.includes(variantId)) {
                  const addToCartBtn = productBlock.querySelector('.rebuy-product-actions .rebuy-button')
                  if(addToCartBtn) {
                    addToCartBtn.click()
                  }
                }
              }
            })
          }
        }
      }
    } else {
      if(bundleWidgetBlock) {
        const productBlocks = [...bundleWidgetBlock.querySelectorAll('.rebuy-product-block')]
        productBlocks.forEach(productBlock => {
          const qtyElem = productBlock.querySelector('button.rebuy-bundle-builder__item-quantity-widget-button')
          if(qtyElem) {
            qtyElem.click()
          }
        })
      }
    }
  }

  document.addEventListener('rebuy.addBundleToCart', function(event){
    const $miniCart = document.querySelector("mini-cart");
    const sectionIDs = $miniCart.getSectionsToRender().map((section) => section.id);
    const url = `${location.pathname}?sections=${sectionIDs}`
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        const data = {
          sections: response
        }
        $miniCart.renderContents(data);
        const $miniCartItems = $miniCart.querySelector('cart-items')
        if($miniCartItems && window.promo_gwp) {
          $miniCartItems.getCartBeforePromo()
        }
        $miniCart.openDrawer()
      })
      .catch((e) => {
        console.error(e);
      });
  });

  document.addEventListener('rebuy.ready', function(event){
    const { widget } = event.detail
    if(rebuyByobSuggestedData) {
      widgetIdList = rebuyByobSuggestedData['list'].map(item => item['widget_id'])
      widgetIdList.push(rebuyByobSuggestedData['builder_id'])
      widgetIdList.sort()

      if(widget.id.toString() === rebuyByobSuggestedData['builder_id']) {
        const sideBarElem = document.querySelector('.rebuy-bundle-builder__group-container-inner')
        const bodyElem = document.querySelector('.rebuy-bundle-builder__group-container-body')
        if(sideBarElem && bodyElem) {
          const suggestedListContainer = sideBarElem.querySelector('.rebuy-suggested-bundle-container')
          if(!suggestedListContainer) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            widgetIdFromUrl = (urlParams.get('preset') || '').trim()

            const suggestedListContainerDiv = document.createElement('div')
            suggestedListContainerDiv.classList.add('rebuy-suggested-bundle-container')
            suggestedListContainerDiv.innerHTML = `
              <div class="rebuy-suggested-bundle-options">
                <select aria-label="${rebuyByobSuggestedData['placeholder']}" class="rebuy-select">
                  <option value="">${rebuyByobSuggestedData['placeholder']}</option>
                  ${rebuyByobSuggestedData['list'].map(item => `<option value="${item['widget_id']}">${item['label']}</option>`).join('')}
                </select>
              </div>
            `
            bodyElem.before(suggestedListContainerDiv)
            const suggestedListSelect = sideBarElem.querySelector('.rebuy-suggested-bundle-container select')
            suggestedListSelect.addEventListener('change', onSelectSuggestedBundle)
            suggestedListSelect.value = widgetIdFromUrl
          }
        }
      }

      if(widgetIdList.includes(widget.id.toString())) {
        document.dispatchEvent(
          new CustomEvent("rebuy-load-bundle-widget", {
            bubbles: true,
            detail: { widgetId: widget.id.toString() },
          })
        )
      }
    }
  });

  document.addEventListener("rebuy-load-bundle-widget", (event) => {
    const widgetId = event.detail?.widgetId;
    if (widgetId) {
      if (loadedWidgetIdList.indexOf(widgetId) === -1) {
        loadedWidgetIdList.push(widgetId);
      }
      loadedWidgetIdList.sort()
      const allElementsIn = widgetIdList.every(element => loadedWidgetIdList.includes(element))
      if(allElementsIn && widgetIdFromUrl && !loadedAllWidgets) {
        loadedAllWidgets = true
        setTimeout(() => renderBySuggestedBundle(widgetIdFromUrl), 1500)
      }
    }
  });
});
